module.exports = __webpack_public_path__ + "static/media/_somaliland.f6a76d14.png";